import { useEffect, useState } from 'react';
import { StorageKey, storage } from './storage';

export const authenticationMethods = ['Email', 'Google', 'Facebook', 'Apple'] as const;

export type AuthenticationMethod = (typeof authenticationMethods)[number];

const isAuthenticationMethod = (value: string | null): value is AuthenticationMethod =>
  authenticationMethods.some((method) => method === value);

export async function saveLastAuthenticationMethod(method: AuthenticationMethod): Promise<void> {
  await storage.saveString(StorageKey.LastAuthenticationMethod, method);
}

export function useLastAuthenticationMethod(shouldRefresh = true): AuthenticationMethod | undefined {
  const [method, setMethod] = useState<AuthenticationMethod>();
  if (!shouldRefresh && method !== undefined) setMethod(undefined);

  useEffect(() => {
    if (!shouldRefresh) {
      return;
    }

    let isActive = true;
    void storage.readString(StorageKey.LastAuthenticationMethod).then((storedMethod) => {
      if (isActive) setMethod(isAuthenticationMethod(storedMethod) ? storedMethod : undefined);
    });

    return () => {
      isActive = false;
    };
  }, [shouldRefresh]);

  return method;
}
